import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import {
  DidGroupDidsTable,
  DidGroupTable,
} from '@components/Numbers/Details/Table';
import { Page500 } from '@containers/ErrorPages/Page500';
import { didGroupsApi } from '@reducers/capacity';
import { numberApi } from '@reducers/number/number';

export const DidGroupTab = ({ did }) => {
  const numberDetails = numberApi.useGetDetailsQuery({ did });
  const didGroupID = numberDetails.data.did_group_id;
  const {
    data: result,
    isLoading,
    isError,
  } = didGroupsApi.useGetDetailsQuery({ id: didGroupID });
  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  const groupDids = result.dids;
  return (
    <>
      <Row>
        <Col>
          <DidGroupTable data={[result]} />
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <DidGroupDidsTable data={groupDids} />
        </Col>
        <Col md={4}>
          <Row className="mb-2">
            <Col>
              <Button
                variant="didxl"
                as={Link}
                to="/order/shared-channels"
                size="sm"
              >
                Order Channels
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                variant="didxl"
                as={Link}
                to={`/capacity/did-groups/${didGroupID}/edit`}
                size="sm"
              >
                Manage DID-Group
              </Button>
            </Col>
          </Row>
        </Col>
        <Col md={6} />
      </Row>
    </>
  );
};
